module.exports = __webpack_public_path__ + "static/media/times-circle.69029b4e.svg";